import styled from 'styled-components'
import PropTypes from 'prop-types'
import { themeGet } from 'styled-system'
import { Heading } from 'grommet'
import {
  toNoBreakContentArray,
  toContentArray,
} from '../../utils/componentHelpers'

const HeaderFour = styled(Heading).attrs(({ dataTestId, children }) => {
  const contentArray = toContentArray(children)
  const noBreakContentArray = toNoBreakContentArray(contentArray)
  return {
    a11yTitle: 'SubHeader',
    'data-testid': dataTestId,
    level: 4,
    responsive: false,
    children: noBreakContentArray,
  }
})`
  color: ${themeGet('colors.heading.level.4')};
  letter-spacing: 0;

  ${themeGet('breakpoints.tablet')} {
    font-size: ${themeGet('heading.level.4.tablet.size')};
    line-height: ${themeGet(`heading.level.4.tablet.height`)};
  }

  ${themeGet('breakpoints.mobile')} {
    font-size: ${themeGet(`heading.level.4.mobile.size`)};
    line-height: ${themeGet(`heading.level.4.mobile.height`)};
  }
`

HeaderFour.propTypes = {
  children: PropTypes.node.isRequired,
  dataTestId: PropTypes.string.isRequired,
  textAlign: PropTypes.string,
}

HeaderFour.defaultProps = {
  textAlign: 'start',
}

HeaderFour.displayName = 'HeaderFour'

export default HeaderFour
